import { gql } from '@apollo/client';

export const totalSpacesGql = gql`
  query totalSpaces($parkingId: String!) {
    totalSpaces(parkingId: $parkingId) {
      allocated
      occupied
    }
  }
`;
